// CardNode.js

import React from "react";
import PropTypes from "prop-types";
import "./card-node.css";
import { Handle, Position } from "reactflow";

const CardNode = ({ id, data, isConnectable, }) => {
  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
        id={`${id}-target-top`}
        isConnectable={isConnectable}
        className="react-flow__handle-target"
      />

      {data.src ? (
        <>
          <Handle
            type="target"
            position={Position.Top}
            id={`${id}-target-top`}
            isConnectable={isConnectable}
            className="react-flow__handle-target"
          />
          <Handle
            type="source"
            position={Position.Right}
            id={`${id}-target- `}
            isConnectable={isConnectable}
            className="react-flow__handle-source"
          />
          <div className="card w-[460px]   bg-base-100 shadow-lg duration-500 hover:shadow-2xl image-full">
            <figure>
              <img src={data.src} alt={data.label} />
            </figure>
            <div className="card-body">
              <p className="text-yellow-300">{data.label}</p>
              <h2 className="card-title">{data.details}</h2>
              <div className="card-actions justify-end">
                <button
                  onClick={() => data.onClick()}
                  className="btn bg-yellow-300 text-black"
                >
                 {data.buttonText} 
                </button>
              </div>
            </div>
          </div>
          <Handle
            type="source"
            position={Position.Bottom}
            id={`${id}-bottom`}
            isConnectable={isConnectable}
            className="react-flow__handle-source"
          />
          <Handle
            type="target"
            position={Position.Left}
            id={`${id}-bottom`}
            isConnectable={isConnectable}
            className="react-flow__handle-target"
          />
        </>
      ) : (
        <>
          <Handle
            type="target"
            position={Position.Top}
            id={`${id}-target-top`}
            isConnectable={isConnectable}
            className="react-flow__handle-target"
          />
          <div
            className={`card-node ${isConnectable ? "connectable" : ""}`}
            style={{ backgroundColor: data.backgroundColor }}
          >
            <div>{data.label}</div>
          </div>
          <Handle
            type="source"
            position={Position.Bottom}
            id={`${id}-bottom`}
            isConnectable={isConnectable}
            className="react-flow__handle-source"
          />
        </>
      )}
    </>
  );
};

CardNode.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string.isRequired,
  }),
  isConnectable: PropTypes.bool,
};

export default CardNode;
